import { metrics } from '@atlassian/browser-metrics';

const backlogPanelEpicAssignInteraction = metrics.interaction({
	key: 'backlog-panel.epic-assign',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		result: '1000_1500_2000_2500_3000_4000',
	},
});

export const setBacklogPanelEpicAssignInteractionStartMark = () => {
	backlogPanelEpicAssignInteraction.start();
};

export const cancelBacklogPanelEpicAssignInteraction = () => {
	backlogPanelEpicAssignInteraction.cancel();
};

export const stopBacklogPanelEpicAssignInteraction = (isCompanyManaged: boolean) => {
	backlogPanelEpicAssignInteraction.stop({ customData: { isCompanyManaged } });
};
